export default import.meta.ROLLDOWN_FILE_URL_9qNyiXf3BXi0A04n6W6ImA